import { Link } from "react-router-dom";

interface BreadcrumbItem {
  name: string;
  path?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="py-4">
      <ol className="flex items-center flex-wrap gap-1 text-sm">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          return (
            <li key={index} className="flex items-center gap-1">
              {index > 0 && (
                <i className="ri-arrow-right-s-line text-foreground-400 text-xs"></i>
              )}
              {!isLast && item.path ? (
                <Link
                  to={item.path}
                  className="text-foreground-500 hover:text-primary-500 transition-colors duration-200"
                >
                  {item.name}
                </Link>
              ) : (
                <span
                  className={
                    isLast ? "text-foreground-900 font-medium" : "text-foreground-500"
                  }
                >
                  {item.name}
                </span>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}